// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* vuetify overrides */
.org-change-field .v-text-field {
  padding: 0;
  margin: 0 4px;
  position: relative;
  top: 6px;
}
.v-application--wrap {
  /* Vue transition styles */
}
.v-application--wrap .fade-enter {
  opacity: 0;
}
.v-application--wrap .fade-enter-active {
  transition: opacity 0.2s 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.v-application--wrap .fade-leave-to {
  opacity: 0;
}
.v-application--wrap .fade-leave-active {
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.actions .v-btn {
  margin: 10px;
}
#admin-app .appBody {
  width: calc(100% - var(--side-bar-width));
  height: 100vh;
  overflow-y: auto;
  display: inline-block;
  color: var(--text-color);
  flex-grow: 1;
  background-color: var(--background-color);
}`, "",{"version":3,"sources":["webpack://./js/modules/admin/components/App/Main.vue","webpack://./Main.vue"],"names":[],"mappings":"AACA,sBAAA;AAEE;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;ACDJ;ADKA;EACE,0BAAA;ACFF;ADGE;EACE,UAAA;ACDJ;ADGE;EACE,0DAAA;ACDJ;ADGE;EACE,UAAA;ACDJ;ADGE;EACE,qDAAA;ACDJ;ADKA;EACE,YAAA;ACFF;ADME;EACE,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,yCAAA;ACHJ","sourcesContent":["\n/* vuetify overrides */\n.org-change-field {\n  .v-text-field {\n    padding: 0;\n    margin: 0 4px;\n    position: relative;\n    top: 6px;\n  }\n}\n\n.v-application--wrap {\n  /* Vue transition styles */\n  .fade-enter {\n    opacity: 0;\n  }\n  .fade-enter-active {\n    transition: opacity 0.2s 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .fade-leave-to {\n    opacity: 0;\n  }\n  .fade-leave-active {\n    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n}\n\n.actions .v-btn {\n  margin: 10px;\n}\n\n#admin-app {\n  .appBody {\n    width: calc(100% - var(--side-bar-width));\n    height: 100vh;\n    overflow-y: auto;\n    display: inline-block;\n    color: var(--text-color);\n    flex-grow: 1;\n    background-color: var(--background-color);\n  }\n}\n","/* vuetify overrides */\n.org-change-field .v-text-field {\n  padding: 0;\n  margin: 0 4px;\n  position: relative;\n  top: 6px;\n}\n\n.v-application--wrap {\n  /* Vue transition styles */\n}\n.v-application--wrap .fade-enter {\n  opacity: 0;\n}\n.v-application--wrap .fade-enter-active {\n  transition: opacity 0.2s 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-application--wrap .fade-leave-to {\n  opacity: 0;\n}\n.v-application--wrap .fade-leave-active {\n  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.actions .v-btn {\n  margin: 10px;\n}\n\n#admin-app .appBody {\n  width: calc(100% - var(--side-bar-width));\n  height: 100vh;\n  overflow-y: auto;\n  display: inline-block;\n  color: var(--text-color);\n  flex-grow: 1;\n  background-color: var(--background-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
